package com.milta.core.localization.translations.ro

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Foto",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "trimis chiar acum",
    fileWaitingConnectionLabel = "în așteptarea conexiunii",
    analysingTitle = "Se citește documentul…",
    analysingSubtitle = "Extragerea livrărilor poate dura câteva secunde.",
    analysingSubtitlePdf = "Claude Haiku extrage livrările — poate dura câteva secunde pe un PDF scanat.",
    stepFileSent = "Fișier trimis",
    stepExtracting = "Extragerea câmpurilor",
    stepReview = "Verificare înainte de adăugare",
    successTitle = "Livrare detectată",
    successSubtitle = "Verificați informațiile înainte de a le adăuga la traseu.",
    addToRouteButton = "Adaugă la traseu",
    scanAnotherButton = "Scanează alt document",
    partialTitle = "Aproape complet",
    partialSubtitle = "Un câmp nu a putut fi citit pe document.",
    missingFieldPlaceholder = "De completat…",
    partialBannerText = "Unele informații nu au putut fi citite. Puteți valida ca atare și le puteți completa mai târziu, sau puteți retrimite un document mai clar.",
    retryFileButton = "Retrimite alt fișier",
    validateAndContinueButton = "Validează și continuă",
    errorTitleUnreadable = "Document ilizibil",
    errorTitleMissingFields = "Informații negăsite",
    errorTitleNetworkError = "Problemă la analiză",
    errorTitleGeneric = "Analiza a eșuat",
    errorSubtitle = "Nu am putut detecta o livrare pe acest fișier.",
    errorBannerSuffixUnreadable = "imagine prea întunecată sau text tăiat. Faceți o fotografie bine cadrată și bine luminată, sau trimiteți un fișier mai clar.",
    errorBannerSuffixMissingFields = "nu s-a găsit nicio informație utilizabilă. Verificați conținutul fișierului sau trimiteți altul.",
    errorBannerSuffixNetworkError = "serviciul de analiză a avut o problemă de rețea. Reîncercați în câteva momente.",
    errorBannerSuffixGeneric = "a apărut o eroare neașteptată în timpul analizei. Reîncercați sau trimiteți alt fișier.",
    retryWithNewFileButton = "Reîncearcă cu alt fișier",
    manualEntryButton = "Introduce manual",
    newDocumentButton = "Importă un document nou",
    serviceUnavailableTitle = "Serviciu temporar indisponibil",
    serviceUnavailableSubtitle = "Analiza automată nu răspunde momentan.",
    serviceUnavailableBanner = "Reîncercați în câteva momente sau completați livrarea manual în așteptare.",
    offlineTitle = "Sunteți offline",
    offlineSubtitle = "Fișierul dvs. este pregătit, dar nu a fost încă trimis.",
    offlineBanner = "Reconectați-vă la internet, apoi relansați analiza. Nimic nu a fost trimis pe server — nu s-a dedus nimic din creditul dvs. IA.",
    retryOfflineButton = "Reîncearcă — fără conexiune",
    unsupportedFormatBanner = "Format de fișier neacceptat. Alegeți o fotografie, un PDF sau un fișier Excel/CSV.",
    validationTitle = "Verificați livrările",
    fileRejectedTitle = "Fișier netrimis",
    fileRejectedSubtitle = "Alegeți alt fișier pentru a continua.",
    bannerFileRequired = "nu a fost selectat niciun fișier. Alegeți un fișier PDF pentru a continua.",
    bannerInvalidPdfFormat = "format neacceptat. Aici sunt acceptate doar fișiere PDF.",
    bannerFileTooLarge = "fișier prea mare. Alegeți un fișier PDF mai ușor.",
    chooseAnotherFileButton = "Alege alt fișier",
    processingCanLeaveNote = "Fișierul a fost trimis. Puteți părăsi acest ecran, analiza continuă. Veți regăsi importul în „Importă livrări”.",
    uploadingPhotoStep = "Se trimite fotografia",
    uploadingFileStep = "Se trimite fișierul",
    photoSentStep = "Fotografie trimisă",
    uploadProgress = "%1 din %2",
    uploadingPhotoBanner = "Trimitere în curs. Păstrați acest ecran deschis până la finalul trimiterii: analiza începe imediat ce fotografia este primită.",
    uploadingFileBanner = "Trimitere în curs. Păstrați acest ecran deschis până la finalul trimiterii: analiza începe imediat ce fișierul este primit.",
    cancelUploadButton = "Anulați trimiterea",
    cancelImportButton = "Anulați importul",
    cancelImportDialogTitle = "Anulați acest import?",
    cancelImportAnalysingScanMessage = "Analiza este oprită imediat și nicio livrare nu va fi adăugată la cursa dvs. Analiza deja lansată rămâne dedusă din creditul dvs. IA.",
    cancelImportAnalysingFileMessage = "Analiza este oprită imediat și nicio livrare nu va fi adăugată la cursa dvs. Analiza deja lansată rămâne dedusă din creditul dvs. IA.",
    cancelImportConfirmButton = "Da, anulați importul",
    continueAnalysisButton = "Continuați analiza",
    cancelImportReviewMessage = "Cele %s livrări detectate sunt șterse și niciuna nu este adăugată la cursa dvs. Reveniți la alegerea sursei.",
    cancelImportReviewMessageSingle = "Livrarea detectată este ștearsă și nu este adăugată la cursa dvs. Reveniți la alegerea sursei.",
    continueReviewButton = "Continuați verificarea",
    importCancelledNotice = "Import anulat. Nu a fost adăugată nicio livrare.",
    serviceUnavailableRetryBanner = "Fișierul este păstrat. Relansați analiza fără a-l trimite din nou sau completați livrarea manual între timp.",
    serviceUnavailableExhaustedBanner = "Acest document nu a putut fi analizat. Adăugați livrările manual sau reluați cu un document nou.",
    errorTitleTooLong = "Document prea lung",
    errorSubtitleTooLong = "Acest document conține prea multe livrări pentru a fi analizat dintr-o dată.",
    errorBannerSuffixTooLong = "împărțiți-l în mai multe fișiere mai scurte sau introduceți livrările manual.",
    errorTitleTooLarge = "Document prea mare",
    errorSubtitleTooLarge = "Acest document depășește dimensiunea pe care o poate procesa analiza.",
    errorBannerSuffixTooLarge = "reduceți-i dimensiunea sau împărțiți-l în mai multe fișiere ori introduceți livrările manual.",
    errorTitleNoDeliveries = "Nicio livrare găsită",
    errorSubtitleNoDeliveries = "Documentul a fost citit, dar nu a fost găsită nicio livrare în el.",
    errorBannerSuffixNoDeliveries = "verificați dacă acesta conține o listă de livrări sau introduceți-le manual.",
    errorTitleSourceExpired = "Fișier expirat",
    errorSubtitleSourceExpired = "Acest fișier nu mai este disponibil pentru o nouă analiză.",
    errorBannerSuffixSourceExpired = "alegeți-l din nou pentru a relansa analiza.",
    errorTitleOriginRouteDeleted = "Import anulat",
    errorSubtitleOriginRouteDeleted = "Cursa de origine a fost ștearsă: acest import este anulat.",
    errorBannerSuffixOriginRouteDeleted = "import anulat, nu a fost adăugată nicio livrare.",
    activeImportHeader = "Import în curs",
    activeImportAnalysingPill = "Analiză în curs",
    activeImportFailedPill = "Analiza a eșuat",
    activeImportReadyPill = "Gata de validat",
    activeImportRunningNote = "Un singur import odată. Așteptați finalul analizei sau anulați-o pentru a importa alt document.",
    activeImportFailedNote = "Un singur import odată. Relansați sau anulați acest import pentru a importa alt document.",
    activeImportReadyNote = "Livrările importate sunt gata. Atingeți pentru a le valida.",
    activeImportRunningOtherRouteNote = "Un import este în curs de analiză pentru cursa din %s. Atingeți pentru a deschide această cursă. Așteptați finalul analizei sau anulați-o pentru a importa alt document.",
    activeImportReadyOtherRouteNote = "Livrările cursei din %s sunt gata. Atingeți pentru a deschide această cursă și a le valida.",
    activeImportFailedOtherRouteNote = "Importul cursei din %s a eșuat. Relansați sau anulați acest import pentru a importa alt document.",
    activeImportRunningNewRouteNote = "Un import este în curs de analiză pentru o cursă nouă. Atingeți pentru a relua crearea ei. Așteptați finalul analizei sau anulați-o pentru a importa alt document.",
    activeImportReadyNewRouteNote = "Livrările cursei noi sunt gata. Atingeți pentru a relua crearea ei și a le valida.",
    activeImportFailedNewRouteNote = "Importul cursei noi a eșuat. Relansați sau anulați acest import pentru a importa alt document.",
    activeImportRouteLink = "Cursa din %s",
    activeImportNewRouteLink = "Cursă nouă (în creare)",
    weekdayNamesInText = listOf("luni", "marți", "miercuri", "joi", "vineri", "sâmbătă", "duminică"),
)
